<template>
  <div class="app-toolbar" :class="{ column }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppToolbar',

  props: {
    column: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    margin-left: math.div($defaultPadding, 3);
    margin-right: math.div($defaultPadding, 3);

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.column {
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;

    > .app-buttons {
      width: 100%;
    }

    > * {
      margin: #{math.div($defaultPadding, 2)} 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
